import { Component, h, Element, Prop } from '@stencil/core';
import { RecordType } from './types';
import { Size } from '../aha-pill/types';

export interface AhaRecordReference extends HTMLAhaRecordReferenceElement {}

/**
 * @slot Default - Contents the `aha-record-reference` element.
 */
@Component({
  tag: 'aha-record-reference',
  styleUrl: 'aha-record-reference.css',
  shadow: true,
})
export class AhaRecordReference {
  @Element() host!: HTMLAhaRecordReferenceElement;

  /**
   * Type of record represented by the reference. Changes the icon shown
   * in the pill.
   */
  @Prop() recordType?: RecordType;

  /**
   * Optional icon override. When provided, this icon will be used instead of the default record type icon.
   */
  @Prop() iconOverride?: string;

  @Prop() size?: Size = 'medium';

  // Get the reference number from slot content for auto-detection
  getReferenceNum(): string | undefined {
    const slotContent = this.host.innerHTML?.trim();
    return slotContent && slotContent.length > 0 ? slotContent : undefined;
  }

  render() {
    return (
      <aha-pill
        color="var(--theme-editor-reference-pill)"
        border-color="var(--theme-editor-reference-pill-border)"
        border-shape="round"
        size={this.size}
      >
        <aha-record-icon
          record-type={this.recordType}
          reference-num={this.getReferenceNum()}
          icon-override={this.iconOverride}
        />
        <slot></slot>
      </aha-pill>
    );
  }
}
